// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Color } from '../../../Graphics';
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { MAMode } from '../IndicatorConstants';
import { IndicatorScriptBase } from '../IndicatorScriptBase';
import { LineStyle } from '../IndicatorScriptBaseEnums';
import { InputParameterCombobox } from '../InputParamaterClasses/InputParameterCombobox';
import { InputParameterInteger } from '../InputParamaterClasses/InputParameterInteger';
export class PO extends IndicatorScriptBase {
    constructor() {
        super();
        // #region Initialization
        this.ProjectName = 'Price Oscillator';
        this.Comments = 'The variation between price moving averages';
        // #endregion
        this.SetIndicatorLine('PO', Color.Blue, 1, LineStyle.SimpleChart);
        this.SetLevelLine('Zero', 0, Color.Gray, 1, LineStyle.SimpleChart);
        this.SeparateWindow = true;
        this.MAType = MAMode.SMA;
        super.InputParameter(new InputParameterCombobox('MAType', 'Type of Moving Average', 0, [
            { Simple: MAMode.SMA },
            { Exponential: MAMode.EMA },
            { Modified: MAMode.SMMA },
            { 'Linear Weighted': MAMode.LWMA }
        ]));
        this.SourcePrice = PriceType.Close;
        super.InputParameter(new InputParameterCombobox('SourcePrice', 'Sources prices for MA', 0, [
            { Close: PriceType.Close },
            { Open: PriceType.Open },
            { High: PriceType.High },
            { Low: PriceType.Low },
            { Typical: PriceType.Typical },
            { Medium: PriceType.Medium },
            { Weighted: PriceType.Weighted }
        ]));
        this.MAPeriod1 = 2;
        super.InputParameter(new InputParameterInteger('MAPeriod1', 'Period of MA1:', 0, 1, 99999, 0, 1));
        this.MAPeriod2 = 25;
        super.InputParameter(new InputParameterInteger('MAPeriod2', 'Period of MA2:', 0, 1, 99999, 0, 1));
    }
    Init() {
        this.IndicatorShortName(this.GetIndicatorShortName());
    }
    GetIndicatorShortName() {
        return 'PO(' + this.MAPeriod1 + ', ' + this.MAPeriod2 + ')';
    }
    getCustomName() {
        return 'PO (' + this.ProjectName + ')';
    }
    createInternalIndicators() {
        this.fastMA = this.Indicators.iMA(this.CurrentData, this.MAPeriod1, this.MAType, 0, this.SourcePrice);
        this.slowMA = this.Indicators.iMA(this.CurrentData, this.MAPeriod2, this.MAType, 0, this.SourcePrice);
        return [this.fastMA, this.slowMA];
    }
    OnQuote() {
        super.OnQuote();
        if (this.CurrentData.Count < this.MAPeriod1 || this.CurrentData.Count < this.MAPeriod2) {
            return;
        }
        this.SetValue(0, 0, this.fastMA.GetValue() - this.slowMA.GetValue());
    }
}
